module.exports = __webpack_public_path__ + "static/media/FinalStatus.e0b376fe.svg";